module.exports = __webpack_public_path__ + "img/logo-slack.07d7b8e1.svg";